module.exports = __webpack_public_path__ + "static/media/arrow_down5b71c4632b59f571ec7ac1729b0152a9.webp";